





















































































import Vue, { PropType } from 'vue'
import Analytics from '@/services/Analytics'
import Consent from '@/types/Consent.interface'
import Media from '@/types/Media.interface'
import Person from '@/types/Person.interface'
import { popPreview } from '@/utility/helpers'
export default Vue.extend({
    props: {
        //  Indicates if the message is a broadcast
        broadcast: {
            type: Boolean,
            default: false
        },
        //  Determines if we hide compliance button and character count
        hideDetails: {
            type: Boolean,
            default: false
        },
        //  The contact the message is being sent to
        person: {
            type: Object as PropType<Person>,
            default: null
        },
        //  Media attached to the message
        media: {
            type: Object as PropType<Media>,
            default: null
        },
        //  Determines if the 'Save Template' checkbox is visible
        saveTemplate: {
            type: Boolean,
            default: false
        },
        // Condition to check if message is type MMS or not
        showMMS: {
            type: Boolean,
            default: false
        },
        //  The text that is displayed in the bubble
        text: {
            type: String,
            required: true
        },
        //  Text area styling from parent component
        textAreaStyling: {
            type: Object,
            default: null
        },
        //  Show the icon
        icon: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    data() {
        return {
            //  The text displayed in the message preview bubble
            bubbleText: null,
            //  Store default message properties (for calculating character length)
            messageConfig: {
                messagePartLimit: 20,
                defaultSMSLength: 160,
                multipartSMSHeaderLength: 7,
                unicodeSMSLength: 70
            },
            //  Bool for opt message warning menu in group broadcasts
            optCompliance: false,
            //  V-model bound to the save template checkbox
            save: false
        }
    },
    mounted() {
        this.setBubbleText()
    },
    computed: {
        //  The css classes applied to the save template checkbox
        checkboxClass(): string {
            //  If we're NOT saving a template, return lightened text
            if (!this.saveTemplate) return 'ml-1 grey--text'

            //  Else, return darkened text
            return 'ml-2 grey--text text--darken-2'
        },
        consent(): Consent {
            return this.$store.getters.consent
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        textareaStyle(): object {
            return {
                color: 'white',
                background: this.broadcast ? '#4D4D4D' : this.$colors.mdPurple70,
                border: `1px solid ${
                    this.broadcast ? '#4D4D4D' : this.$colors.mdPurple70
                }`,
                borderRadius: `10px 10px ${this.broadcast ? '10px' : '0px'} 10px`,
                padding: '15px',
                width: '100%',
                textAlign: 'left'
            }
        }
    },
    methods: {
        appendConsentMessage(): void {
            //  If the consent message does NOT exist, do nothing
            if (!this.consent) return

            //  Get our opt in message
            const optIn = this.consent && this.consent.opt_in_message

            //  Append consent message
            const text = `${this.text}<br><br>${optIn}`

            //  Set the bubble text
            this.bubbleText = text
        },
        async needsConsentMessage(): Promise<boolean> {
            //  Return false if no person
            if (!this.person) return false

            //  Return false if person does not have default phone
            if (!this.person.phone_default.msisdn) return false

            //  Else, get the persons' msisdn
            const msisdn = this.person.phone_default.msisdn

            //  Check if the msisdn has been sent a consent message
            const consentSent = await this.$store.dispatch('consentSentGet', msisdn)

            //  Determine if the message needs a consent message appended
            const needsOpt = consentSent === null || consentSent === undefined

            //  Return true if opt out has not been sent
            return needsOpt
        },
        //  Event that occurs when the save template checkbox is toggled
        onSaveChanged(): void {
            //  Report action to analytics
            Analytics.track('MessagePreviewTemplateSaveToggled', { toggled: this.save })

            //  Emit to MessagePreview the save value
            this.$emit('saveChanged', this.save)
        },
        popPreview(media: Media): void {
            popPreview(media)
        },
        async setBubbleText(): Promise<void> {
            //  Set the bubble text (for fast rendering before we append the consent message)
            this.bubbleText = this.text

            //  If consent does NOT exist, do nothing else
            if (!this.consent) return

            //  Else, if this is a broadcast, we always append the consent message
            // if (this.broadcast) return this.appendConsentMessage()

            //  Else, check if the 'append_all' setting is enabled (we use == here so 0/1 will evaluate as false/true)
            const appendToAll = this.consent.append_all == false ? false : true

            //  If 'append_all' is NOT enabled, we do NOT append the message, do nothing
            if (!appendToAll) return

            //  Else, check if the phone has already received a consent message
            const needsConsentMessage = await this.needsConsentMessage()

            //  If the message needs the consent message, append it!
            if (needsConsentMessage) this.appendConsentMessage()
        }
    },
    watch: {
        text(): void {
            this.setBubbleText()
        },
        consent(): void {
            this.setBubbleText()
        }
    }
})
